module.exports = __webpack_public_path__ + "img/ych.2f739d22.jpg";